import React from "react";
import Lottie from "lottie-react";
import uploadAnimation from "../../assets/upload_animation.json";
import { Overlay, ProgressText } from "./UploadOverlay.styles";

interface Props {
  open: boolean;
  step: number;
  total: number;
}

const UploadOverlay: React.FC<Props> = ({ open, step, total }) => {
  if (!open) return null;

  return (
    <Overlay>
      <Lottie
        animationData={uploadAnimation}
        loop
        style={{ width: 220, height: 220 }}
      />
      <ProgressText>
        Uploading Documents {step}/{total}
      </ProgressText>
    </Overlay>
  );
};

export default UploadOverlay;
